import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom"; // Changed from next/navigation
import LoginForm from "./LoginForm";
import { EFieldInputTypes, IField, IFormData } from "src/configs/types";
import { useForm } from "src/configs/hooks";
import { signIn } from "src/services/users/userServices";
import {
  userActionSetNotification,
  userActionSignIn,
} from "src/redux/users/userAction";
import { IUserState } from "src/redux/users/userReducer";

enum ESignInFieldNames {
  Email = "email",
  Password = "password",
}

const signInFields: IField<ESignInFieldNames>[] = [
  {
    name: ESignInFieldNames.Email,
    title: "Email",
    required: true,
    col: 12,
    inputType: EFieldInputTypes.Email,
  },
  {
    name: ESignInFieldNames.Password,
    title: "Password",
    required: true,
    col: 12,
    inputType: EFieldInputTypes.Password,
  },
];

export default function SignIn() {
  const [form, onChange] = useForm({ email: "", password: "" }, signInFields);
  const navigate = useNavigate(); // Changed from useRouter
  const dispatch = useDispatch();

  const onSubmit = useCallback(
    async (formData: IFormData) => {
      const response = await signIn(formData);

      // Store notification in Redux instead of showing it directly
      dispatch(
        userActionSetNotification({
          message:
            response?.error || response?.message || "Something went wrong.",
          type:
            response?.error ||
            !response?.message ||
            (response?.statusCode || 0) > 300
              ? "error"
              : "success",
        }),
      );

      if (!response?.user) return;
      localStorage.setItem("token", response.access_token);
      localStorage.setItem("tokenExpiresIn", response.expires_in);
      localStorage.setItem("tokenIssuedAt", Date.now().toString());
      dispatch(userActionSignIn(response.user as IUserState));
      navigate("/product-finder"); // Changed from router.push
    },
    [dispatch, navigate],
  );

  return (
    <div className="min-h-screen flex items-center justify-center px-4 -mt-16">
      <LoginForm
        fields={signInFields}
        form={form}
        onChange={onChange}
        onSubmit={onSubmit}
      />
    </div>
  );
}
